export default __webpack_public_path__ + "static/media/project-off-track-health.1b78a83e.svg";